import { render, staticRenderFns } from "./TesseractIcon.vue?vue&type=template&id=4501f756&"
import script from "./TesseractIcon.vue?vue&type=script&lang=js&"
export * from "./TesseractIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports